export default __webpack_public_path__ + "static/media/Desktop-ModelS.e3d22a07.jpeg";